export default {
  main: {
    debug: false,
  },
  livechat: {
    scriptId: 'Microsoft_Omnichannel_LCWidget',
    primarySrc: 'https://oc-cdn-public-oce.azureedge.net/livechatwidget/scripts/LiveChatBootstrapper.js',
    fallbackSrc: 'https://ocprodpublicocegs.blob.core.windows.net/livechatwidget/scripts/LiveChatBootstrapper.js',
    lcwVersion: 'prod',
    appId: '',
    orgId: '',
    orgUrl: '',
    domain: '',
    category: 'ACC General Enq',
    otherChatSrc: '',
    otherChatInitId: '',
    otherChatChatId: '',
  },
};
